import { CurrencyPipe, formatDate } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { NgxSpinnerService } from 'ngx-spinner';
import { AppBaseDataService } from 'src/app/_services/app-base-data.service';
import { BaseService } from 'src/app/_services/base.service';
import { FilterServiceService } from 'src/app/_services/filter-service.service';
import { GlobalService } from 'src/app/_services/global.service';
import { InventoryService } from 'src/app/_services/inventory.service';
import { ReportsService } from 'src/app/_services/reports.service';
import * as XLSX from 'xlsx';
import * as FileSaver from 'file-saver';
import jsPDF from 'jspdf';
import 'jspdf-autotable';
export interface Daily_Money_Report {
  storeNumber: string;
  stationId: string;
  cashierId: string;
  cash: number;
  cashRefunds: number;
  change: number;
  check: number;
  checkRefunds: number;
  creditCard: number;
  creditCardRefunds: number;
  debitCard: number;
  debitRefunds: number;
  dialupCreditCard: number;
  dialupCCRefunds: number;
  giftCard: number;
  giftCardRefunds: number;
  totalInvoices: number;
  taxableSales: number;
  nonTaxableSales: number;
  totalNetSales: number;
  salesTax: number;
  returnInvoicesTax: number;
  avgTicket: number;
  totalTaxCollected: number;
  totalGrossSales: number;
  paidOuts: number;
  cashDrop: number;
  lastDrop: number;
  dropQty: number;
  zelleTotal: number;
  venomoTotal: number;
  paypalTotal: number;
  cashDiscount?:number
  zelleRefunds: number;
  venomoRefunds: number;
  paypalRefunds: number;

}




@Component({
  selector: 'app-daily-money-report',
  templateUrl: './daily-money-report.component.html',
  styleUrls: ['./daily-money-report.component.scss']
})
export class DailyMoneyReportComponent implements OnInit {

  _globals = GlobalService

  dataList: Daily_Money_Report[] = [];
  dataListDisplay: any[] = [];
  sectionSummaries: any[] = [];
  locationIds: string[] = [];
  constructor(
    private _inventoryService: InventoryService,
    private _bs: BaseService,
    private _reportService: ReportsService,
    private _abd: AppBaseDataService,
    private _spinner: NgxSpinnerService,
    private currencyPipe: CurrencyPipe,
    public _filterService: FilterServiceService,
  ) { }

  private isTotalRow(name: string): boolean {
    return /^total\b/i.test(String(name).trim());
  }

  private isZeroValue(value: any): boolean {
    return Number(String(value).replace(/[^0-9.-]/g, '')) === 0;
  }

  ngOnInit(): void {
    this._globals.componentName = 'Daily Money Report'

    if (!this._filterService.dateRange || this._filterService.dateRange.length < 1)
      this._filterService.initDates()

    this._filterService.selectedLocation = this._abd.locations;
    this.getDataList()
  }

  ngOnDestroy() {
    this._globals.componentName = ''
  }

  getLocationsList() {
    let self = this;
    this.locationIds = [];
    let selLocation = this._filterService.selectedLocation;
    selLocation = (typeof selLocation != 'undefined' && selLocation instanceof Array) ? selLocation : [selLocation];
    selLocation.map(function (value: { locationId: { toString: () => string; }; }) {
      self.locationIds.push(value.locationId.toString())
    })
  }

  getDataList() {

    this.getLocationsList();


    if (!this._abd.dateRange) {
      this._abd.initDates()
    }

    const data = {
      "ReportName": 'DailyMoneyReport',
      "Parameter": {
        "StartDate": formatDate(this._filterService.dateRange[0], 'MM/dd/yyyy', 'en-US'),
        "EndDate": formatDate(this._filterService.dateRange[1], 'MM/dd/yyyy', 'en-US'),
        "LocationIds": this.locationIds
      }
    }

    const url = this._abd.reports.filter(x => x.componentName == 'Daily Money Report')[0].reportURL;
    this._abd.showSpinner();
    this._bs.httpPost(url, JSON.stringify(data)).subscribe(res => {
      this.dataList = res.data;
      var obj1 = [
        {
          heading: 'System Money Total',
          data: [{
            name: 'Taxable Sales:',
            value: GlobalService.formatNumberWithCurrencySign(this.dataList.map(x => x.taxableSales).reduce((a, b) => a + b, 0))
          },
          {
            name: 'Sales-Tax Collected:',
            value: GlobalService.formatNumberWithCurrencySign(this.dataList.map(x => x.totalTaxCollected).reduce((a, b) => a + b, 0))
          },
          {
            name: 'Non Taxable Sales:',
            value: GlobalService.formatNumberWithCurrencySign(this.dataList.map(x => x.nonTaxableSales).reduce((a, b) => a + b, 0))
          },
          {
            name: 'Total Gross Sales:',
            value: GlobalService.formatNumberWithCurrencySign(this.dataList.map(x => x.totalGrossSales).reduce((a, b) => a + b, 0))
          }]
        },
        {
          heading: 'Sales Transactions',
          data: [
            {
              name: 'Cash:',
              value: GlobalService.formatNumberWithCurrencySign(this.dataList.map(x => x.cash).reduce((a, b) => a + b, 0))
            },
            {
              name: 'Credit/Debit Cards:',
              value: GlobalService.formatNumberWithCurrencySign(this.dataList.map(x => x.creditCard + x.debitCard).reduce((a, b) => a + b, 0))
            },
            {
              name: 'Venmo',
              value: GlobalService.formatNumberWithCurrencySign(this.dataList.map(x => x.venomoTotal).reduce((a, b) => a + b, 0))
            },
            {
              name: 'Zelle',
              value: GlobalService.formatNumberWithCurrencySign(this.dataList.map(x => x.zelleTotal).reduce((a, b) => a + b, 0))
            },
            {
              name: 'Paypal',
              value: GlobalService.formatNumberWithCurrencySign(this.dataList.map(x => x.paypalTotal).reduce((a, b) => a + b, 0))
            },

            {
              name: 'Credit Cards (Dial-Up):',
              value: GlobalService.formatNumberWithCurrencySign(this.dataList.map(x => x.dialupCreditCard).reduce((a, b) => a + b, 0))
            },
            {
              name: 'Gift Card Redeemed:',
              value: GlobalService.formatNumberWithCurrencySign(this.dataList.map(x => x.giftCard).reduce((a, b) => a + b, 0))
            },
            {
              name: 'Total Sales TRX:',
              value: GlobalService.formatNumberWithCurrencySign(this.dataList.map(x => x.cash + x.giftCard + x.debitCard + x.creditCard + x.dialupCreditCard + x.zelleTotal + x.paypalTotal + x.venomoTotal).reduce((a, b) => a + b, 0))
            }]
        },
        {
          heading: 'Sale TRX Adjustments',
          data: [{
            name: 'Cash Refunds:',
            value: GlobalService.formatNumberWithCurrencySign(this.dataList.map(x => x.cashRefunds).reduce((a, b) => a + b, 0))
          }, {
            name: 'Credit/Debit Card Refunds:',
            value: GlobalService.formatNumberWithCurrencySign(this.dataList.map(x => x.creditCardRefunds + x.debitRefunds + x.dialupCCRefunds).reduce((a, b) => a + b, 0))
          },
          {
            name: 'Venmo Refunds',
            value: GlobalService.formatNumberWithCurrencySign(this.dataList.map(x => x.venomoRefunds).reduce((a, b) => a + b, 0))
          },
          {
            name: 'Zelle Refunds',
            value: GlobalService.formatNumberWithCurrencySign(this.dataList.map(x => x.zelleRefunds).reduce((a, b) => a + b, 0))
          },
          {
            name: 'Paypal Refunds',
            value: GlobalService.formatNumberWithCurrencySign(this.dataList.map(x => x.paypalRefunds).reduce((a, b) => a + b, 0))
          }, 
          {
            name: 'Paid Out:',
            value: GlobalService.formatNumberWithCurrencySign(this.dataList.map(x => x.paidOuts).reduce((a, b) => a + b, 0))
          },
          {
            name: 'Cash Discount:',
            value: GlobalService.formatNumberWithCurrencySign(this.dataList.map(x => x.cashDiscount).reduce((a, b) => a + b, 0))
          },
           {
            name: 'Total Sales TRX Adjustments:',
            value: GlobalService.formatNumberWithCurrencySign(this.dataList.map(x => x.cashRefunds + x.creditCardRefunds + x.paidOuts + x.debitRefunds + x.zelleRefunds + x.paypalRefunds + x.venomoRefunds).reduce((a, b) => a + b, 0))
          }, {
            name: 'Total Adjusted Sales TRX:',
            value: GlobalService.formatNumberWithCurrencySign(this.dataList.map(x => (x.cash + x.giftCard + x.debitCard + x.creditCard + x.dialupCreditCard) - (x.cashRefunds + x.creditCardRefunds + x.paidOuts + x.debitRefunds + x.zelleRefunds + x.paypalRefunds + x.venomoRefunds)).reduce((a, b) => a + b, 0))
          }]
        },
        {
          heading: 'Cash Drop Details',
          data: [{
            name: 'Cash Drop:',
            value: GlobalService.formatNumberWithCurrencySign(this.dataList.map(x => x.cashDrop).reduce((a, b) => a + b, 0))
          }, {
            name: 'Last Drop:',
            value: GlobalService.formatNumberWithCurrencySign(this.dataList.map(x => x.lastDrop).reduce((a, b) => a + b, 0))
          }, {
            name: 'Drop Qty:',
            value: this.dataList.map(x => x.dropQty).reduce((a, b) => a + b, 0)
          }]
        }


      ]

      this.dataListDisplay = obj1;
      // Header summary for each collapsible section: line count excludes "Total..." rows, and
      // the header figure is the last total (or the first row when a section has no total).
      // Kept off dataListDisplay because exportPdf()/exportExcel() iterate it.
      this.sectionSummaries = obj1.map((section,index )=> {
        const totals = section.data.filter(x => this.isTotalRow(x.name));
        return {
          heading: section.heading,
          rows: section.data.map(x => ({ name: String(x.name).replace(/:\s*$/, ''), value: x.value, isZero: this.isZeroValue(x.value) })),
          lines: section.data.length - totals.length,
          total: (totals.length ? totals[totals.length - 1] : section.data[0])?.value,
         expanded: index === 0
        };
      });
      this._abd.hideSpinner();


    })
  }

  filterButtonPressed() {
    this.getDataList()
  }

  callbackFuncFromFilter(event) {
    this.getDataList()
  }

  exportExcel() {
    const summaryRows = this.getExportRows();
    const workbook = {
      Sheets: {
        'Daily Money Report': XLSX.utils.aoa_to_sheet(summaryRows),
      },
      SheetNames: ['Daily Money Report']
    };

    const excelBuffer = XLSX.write(workbook, { bookType: 'xlsx', type: 'array' });
    const data: Blob = new Blob([excelBuffer], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
    const filename = 'daily-money-report-' + formatDate(new Date(), 'MMM/dd/yyyy', 'en-US') + '.xlsx'
    FileSaver.saveAs(data, filename);
  }

  exportPdf() {
    const doc = new jsPDF('p', 'mm', 'a4');
    doc.setFontSize(18)
    doc.setTextColor(40)
    doc.text('DAILY MONEY REPORT', 14, 18)

    const summary = this.getSummaryExportRows();
    doc['autoTable']({
      head: [['Summary', 'Value']],
      body: summary,
      startY: 26
    })

    let startY = doc['lastAutoTable']?.finalY ? doc['lastAutoTable'].finalY + 10 : 50;
    this.dataListDisplay.forEach((section, index) => {
      if (index > 0 && startY > 245) {
        doc.addPage();
        startY = 18;
      }

      doc.setFontSize(13)
      doc.text(section.heading, 14, startY)
      doc['autoTable']({
        head: [['Name', 'Value']],
        body: section.data.map((row) => [row.name, row.value]),
        startY: startY + 4
      })
      startY = doc['lastAutoTable']?.finalY ? doc['lastAutoTable'].finalY + 10 : startY + 45;
    })

    const filename = 'daily-money-report-' + formatDate(new Date(), 'MMM/dd/yyyy', 'en-US') + '.pdf'
    doc.save(filename);
  }

  private getSummaryExportRows(): any[][] {
    if (!this.dataList.length) {
      return [['No data found', '']]
    }

    return [
      ['Total Invoices', this.dataList[0].totalInvoices],
      ['Avg. Ticket', GlobalService.formatNumberWithCurrencySign(this.dataList[0].avgTicket)],
      ['Total Sales', GlobalService.formatNumberWithCurrencySign(this.dataList[0].totalGrossSales)]
    ]
  }

  private getExportRows(): any[][] {
    const rows = [['Daily Money Report'], [''], ['Summary', 'Value']];
    rows.push(...this.getSummaryExportRows());

    this.dataListDisplay.forEach(section => {
      rows.push(['']);
      rows.push([section.heading, '']);
      rows.push(['Name', 'Value']);
      section.data.forEach(row => {
        rows.push([row.name, row.value]);
      });
    });

    return rows;
  }

}
